import axios from "axios";
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "content-type": "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) return config;

    config.headers.Authorization = `Bearer ${accessToken}`;

    return config;
  },
  (err) => Promise.reject(err)
);
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      (error.response && error.response.status === 401) ||
      (error.response && error.response.status === "username_is_not_existed")
    ) {
      localStorage.removeItem("accessToken");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
